import { KYMW1104Model } from './../kymw1104.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品情報初期処理クラス
 *
 * @export GetSelectedCodesForCoopsService
 * @class GetSelectedCodesForCoopsService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetSelectedCodesForCoopsService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1104Model;
  private pCode: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSelectedCodesForCoopsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetSelectedCodesForCoopsService
   */
  execute(model: KYMW1104Model, pCode: string, successFunc: Function = null): void {
    this.model = model;
    this.pCode = pCode;
    this.successFunc = successFunc;
    this.send('getSelectedCodesForCoops', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSelectedCodesForCoopsService
   */
  success(data: any): void {
    this.model.updateSelectedCodesForCoops(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
